<template>
  <Content id="loginLog">
    <div slot="search">
      <Form :label-width="40" :model="search">
        <Row :gutter="13">
          <Col>
            <FormItem label="日期">
              <DatePicker type="date" style="width:115px ;" placeholder="起始日期" format="yyyy-MM-dd" v-model="search.startDate"  @on-change="changestart" :editable = "false"></DatePicker>
              <DatePicker type="date" style="width:115px ;" placeholder="结束日期" format="yyyy-MM-dd" v-model="search.endDate" @on-change="changeend" :editable = "false"></DatePicker>
            </FormItem>
          </Col>
          <Col><FormItem label="账号"><Input v-model="search.username" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="微信标识" :label-width="70"><Input v-model="search.openid" :clearable="true"/></FormItem></Col>
          <Col>
            <FormItem label="账号类型" :label-width="70">
              <Select v-model="search.accountType">
                <Option v-for="item in accountTypeList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="来源">
              <Select v-model="search.source">
                <Option v-for="item in sourceList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              <Button type="primary" @click="query">查询</Button>&nbsp;
            </div>
          </Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" highlight-current-row highlight-selection-row row-key="id"
              :row-class-name="tableRowClassName" @row-click="selectrow" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center', 'height':'40px'}" :max-height="tableHeight">

      <el-table-column align="center" prop="username" label="账号" min-width="110"/>
      <el-table-column align="center" prop="realName" label="真实姓名" min-width="80"/>
      <el-table-column align="center" prop="source" label="来源" min-width="80"/>
      <el-table-column align="center" prop="loginIp" label="登录ip" min-width="100"/>
      <el-table-column align="center" prop="openid" label="微信标识" min-width="150"/>
      <el-table-column align="center" prop="accountType" label="账号类型" min-width="100">
        <template slot-scope="{row}">{{ row.accountType === 1 ? "正式账号" : row.accountType === 2 ? "临时账号" : "" }}</template>
      </el-table-column>
      <el-table-column align="center" prop="remark" label="备注" min-width="150"/>
      <el-table-column align="center" prop="loginTime" label="登录时间" min-width="170"/>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>


  </Content>
</template>
<script>
import {_getList} from "@/services/manage/loginLog";
import dayjs from "dayjs";
export default {
  name: "LoginLog",
  data() {
    return {
      search: {
        patientId:"",
        model:"",
        endDate:dayjs().format('YYYY-MM-DD'),
        startDate:dayjs().format('YYYY-MM-DD')
      },
      sourceList:[
        {label: '全部', value: ''},
        {label: 'PC端', value: '公卫体检-PC端'},
        {label: '小程序', value: '小程序'},
      ],
      accountTypeList:[
        {label: '全部', value: ''},
        {label: '正式账号', value: 1},
        {label: '临时账号', value: 2},
      ],
      dataList:[],
      pageList:{
        currentPage:1,
        pageSize:10,
        total: 0
      },
      tableHeight: 0,
      currentRowIndex: null,
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {
    this.handleDataList();
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    query() {
      this.pageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _getList({
        ...this.search,
        ...this.pageList,
      }).then(res => {
          if (res.errcode == 1){
            this.dataList = res.data.records;
            this.pageList.total = res.data.total;
          } else {
            this.$message.error(res.errmsg)
          }
        }).catch(() => {});
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e){
      this.pageList.currentPage=e
      this.handleDataList();
    },
    chagepagesize(e){
      this.pageList.pageSize=e
      this.handleDataList();
    },
    changestart(e){
      this.search.startDate=e
    },
    changeend(e){
      this.search.endDate=e
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}

</style>
